import sanitizeHtml from 'sanitize-html';

type HtmlParserProps = {
  html: string;
};

export function HtmlParser(props: HtmlParserProps): JSX.Element {
  const hasLink = props.html.includes('<a');
  return (
    <span
      style={{
        color: hasLink ? 'blue' : undefined,
        textDecoration: hasLink ? 'underline' : undefined
      }}
      dangerouslySetInnerHTML={{
        __html: sanitizeHtml(props.html, { allowedTags: ['a', 'b', 'br'] })
      }}
    />
  );
}
